import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import history from "./history";
import "./locales";
import useSecurityGuard from "utils/hooks/useSecurityGuard";
// import FirebaseNotification from "components/template/FirebaseNotification";
// const environment = process.env.NODE_ENV;

// if (appConfig.enableMock) {
//   mockServer({ environment });
// }

function App() {
  useSecurityGuard();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter history={history}>
            <Theme>
              <Layout />
            </Theme>
          </BrowserRouter>
        </PersistGate>
      </Provider>
      {/* <FirebaseNotification /> */}
    </>
  );
}


export default App;
